<template lang="pug">
div
  inventory-listing
</template>

<script>
import InventoryListing from '@/components/hq/inventory/InventoryListing.vue'

export default {
  components: { InventoryListing },
}
</script>

<style scoped>
</style>
